window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

window.jQuery = window.$ =  require('jquery');
require('bootstrap');
require('jquery.mmenu');

/**
 * Slick - slide anything! - a life saver when it comes to all sorts of sliders!
 */
require('slick-carousel');

/**
 * Need to pop-up something? magnificPopup eats it all.
 */
require('magnific-popup');


/**
 * Everytone likes feedback! Why not deliver it in style?
 */
require('sweetalert');

/**
 * Last but not least, no web page is
 * complete without it, well in EU that is.
 */
require('cookieconsent');

/**
 * Strap that Vue back in!
 */
window.Vue = require('vue');